<template>
  <div class="user_index">
    <div class="shop_top no_nav">
      <shop-top
        :subnav_show="false"
        :change_color="true"
      ></shop-top>
    </div>
    <div class="user_body">
      <div
        class="width_center_1200"
        style="padding-bottom:40px;"
      >
        <div class="user_left">
          <div class="user_info_block">
            <div class="user_info" @click="$router.push('/user/info')">
              <img
                width="44px"
                height="44px"
                :src="user.photo || '/images/default_avatar.png'"
                alt=""
              >
              <div class="cont">
                <div class="name">{{ user.nickname }}</div>
                <div class="account">{{ lang.member_card_number }}：{{ user.id }}</div>
              </div>
            </div>
            <div class="user_data">
              <router-link to="/user/record" class="item">
                <div class="num">{{ user.integral }}</div>
                <div class="tit">{{ lang.points }}</div>
              </router-link>
              <router-link to="/user/coupon" class="item">
                <div class="num">{{ user.couponcount }}</div>
                <div class="tit">{{ lang.coupon_title }}</div>
              </router-link>
            </div>

          </div>
          <div class="user_cat">
            <div class="user_cat_title">{{ lang.my_order }}</div>
            <div class="user_cat_list">
              <ul>
                <li :class="{ cur: router_name === 'user_order' && order_type === 0 }">
                  <router-link to="/user/index">
                    <svg-icon :iconClass="router_name === 'user_order' && order_type === 0 ? 'order_icon1_cur' : 'order_icon1'" />{{ lang.order_text1 }}
                  </router-link>
                </li>
                <li :class="{ cur: router_name === 'user_coupon' }">
                  <router-link to="/user/coupon">
                    <svg-icon :iconClass="router_name === 'user_coupon' && order_type === 0 ? 'coupon_cur' : 'coupon'" />{{ lang.coupon }}
                  </router-link>
                </li>
                <li :class="{ cur: router_name === 'user_order' && order_type === 1 }">
                  <router-link to="/user/index?type=1">
                    <svg-icon :iconClass="router_name === 'user_order' && order_type === 1 ? 'order_icon2_cur' : 'order_icon2'" />{{ lang.order_text2 }}
                  </router-link>
                </li>
                <li :class="{ cur: router_name === 'user_order' && order_type === 2 }">
                  <router-link to="/user/index?type=2">
                    <svg-icon :iconClass="router_name === 'user_order' && order_type === 2 ? 'order_icon3_cur' : 'order_icon3'" />{{ lang.order_text3 }}
                  </router-link>
                </li>
                <li :class="{ cur: router_name === 'user_order' && order_type === 4 }">
                  <router-link to="/user/index?type=4">
                    <svg-icon :iconClass="router_name === 'user_order' && order_type === 4 ? 'order_icon5_cur' : 'order_icon5'" />{{ lang.order_text4 }}
                  </router-link>
                </li>
                <li :class="{ cur: router_name === 'user_order' && order_type === 5 }">
                  <router-link to="/user/index?type=5">
                    <svg-icon :iconClass="router_name === 'user_order' && order_type === 5 ? 'order_icon6_cur' : 'order_icon6'" />{{ lang.order_text5 }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="user_cat_title">{{ lang.btn_tit }}</div>
            <div class="user_cat_list">
              <ul>
                <li>
                  <router-link to="/points/index">
                    <svg-icon iconClass="user_action1" />{{ lang.btn_text1 }}
                  </router-link>
                </li>
                <li :class="{ cur: router_name === 'user_card' }">
                  <router-link to="/user/card">
                    <svg-icon :iconClass="router_name === 'user_card' ? 'user_action7_cur' : 'user_action7'" />{{ lang.btn_text6 }}
                  </router-link>
                </li>
                <li>
                  <router-link to="/goods/collect">
                    <svg-icon iconClass="user_action2" />{{ lang.btn_text2 }}
                  </router-link>
                </li>
                <li>
                  <router-link to="/contact_us">
                    <svg-icon iconClass="user_action4" />{{ lang.btn_text3 }}
                  </router-link>
                </li>
                <li>
                  <router-link to="/about_us">
                    <svg-icon iconClass="user_action5" />{{ lang.btn_text4 }}
                  </router-link>
                </li>
                <li @click="loginOut">
                  <router-link to="">
                    <svg-icon iconClass="user_action6" />{{ lang.btn_text5 }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="user_right">
          <router-view></router-view>
        </div>

        <div class="clear"></div>
      </div>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ShopTop from '@/components/ShopHead/index';
import ShopFoot from '@/components/ShopFoot/index.vue';
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  props: {},
  data() {
    return {
      user_info: {},
      bfb: 0,
      is_check: false
    };
  },
  watch: {},
  computed: {
    lang() {
      return this.$t('member');
    },
    ...mapGetters(['user']),
    router_name() {
      return this.$route.name;
    },
    order_type() {
      return parseFloat(this.$route.query.type) || 0;
    }
  },
  methods: {
    loginOut() {
      this.$confirm(this.lang.tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.user_body {
  background: #f1f1f1;
}
.user_body:after {
  content: '';
  display: block;
  clear: both;
}
.user_left {
  float: left;
  width: 220px;
  margin-right: 15px;
  padding-top: 20px;
  .user_info_block {
    background: #fff;
    padding: 20px 15px;
    border-radius: 12px;
    .user_info {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding-bottom: 14px;
      margin-bottom: 14px;
      border-bottom: 1px solid #ddd;
      img {
        border-radius: 50%;
      }
      .cont {
        margin-left: 8px;
        .name {
          color: #4f4f4f;
          font-size: 14px;
          padding-bottom: 2px;
        }
        .account {
          color: #aaaaaa;
          font-size: 12px;
        }
      }
    }
    .user_data {
      display: flex;
      .item {
        text-align: center;
        width: 50%;
        cursor: pointer;
        .num {
          font-weight: bold;
          color: #ec9221;
          font-size: 14px;
        }
        .tit {
          color: #4f4f4f;
          font-size: 12px;
        }
      }
    }
  }
  .user_cat {
    margin-top: 15px;
    background: #fff;
    padding: 20px 15px 5px;
    border-radius: 12px;
    font-size: 14px;
    .user_cat_title {
      font-size: 14px;
      color: #4f4f4f;
      margin-bottom: 16px;
    }
    .user_cat_title i {
      margin-right: 10px;
      font-size: 14px;
      color: #ca151e;
    }
    .user_cat_list {
      padding-bottom: 10px;
      ul li {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        height: 26px;
        line-height: 26px;
        a {
          display: flex;
          align-items: center;
        }
        &.cur {
          width: 190px;
          background: #ec9221;
          cursor: pointer;
          a {
            color: #fff !important;
          }
        }
        span {
          padding: 0 12px;
        }
        a {
          font-size: 12px;
          color: #4f4f4f;
        }
        a:hover {
          color: #ec9221;
        }
      }
    }
    .user_cat_list:last-child {
      border-bottom: none;
    }
  }
}
.user_right {
  float: left;
  width: 965px;
  padding-top: 20px;
}
/deep/ .svg-icon {
  margin: 0 12px;
}
</style>